import React from 'react';
import { LightbulbIcon, TrendingUpIcon, ShieldIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface Recommendation {
  id: string;
  title: string;
  description: string;
  impact: 'high' | 'medium' | 'low';
  category: 'revenue' | 'security' | 'efficiency';
  link: string;
}
export function RecommendationsWidget() {
  const navigate = useNavigate();
  const recommendations: Recommendation[] = [{
    id: '1',
    title: 'Enable 3D Secure',
    description: 'Reduce fraud by 87%',
    impact: 'high',
    category: 'security',
    link: '/settings?tab=security'
  }, {
    id: '2',
    title: 'Enable Alipay and WeChat Pay',
    description: 'Expand payment options for Asian markets',
    impact: 'high',
    category: 'revenue',
    link: '/settings?tab=payments'
  }];
  const getImpactColor = (impact: string) => {
    switch (impact) {
      case 'high':
        return 'text-green-700 bg-green-50';
      case 'medium':
        return 'text-yellow-700 bg-yellow-50';
      case 'low':
        return 'text-gray-700 bg-gray-50';
      default:
        return 'text-gray-700 bg-gray-50';
    }
  };
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'revenue':
        return <TrendingUpIcon size={14} className="text-green-600" data-id="element-1909" />;
      case 'security':
        return <ShieldIcon size={14} className="text-blue-600" data-id="element-1910" />;
      case 'efficiency':
        return <LightbulbIcon size={14} className="text-purple-600" data-id="element-1911" />;
      default:
        return <LightbulbIcon size={14} className="text-gray-600" data-id="element-1912" />;
    }
  };
  return <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1913">
      <div className="flex items-center justify-between mb-3" data-id="element-1914">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center" data-id="element-1915">
          <LightbulbIcon size={16} className="mr-2 text-yellow-500" data-id="element-1916" />
          Recommendations
        </h3>
        <span className="text-xs text-gray-500" data-id="element-1917">Personalized</span>
      </div>

      <div className="space-y-2" data-id="element-1918">
        {recommendations.map(rec => <button key={rec.id} onClick={() => navigate(rec.link)} className="w-full text-left p-2 rounded-md border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all group" data-id="element-1919">
            <div className="flex items-start justify-between" data-id="element-1920">
              <div className="flex-1 min-w-0" data-id="element-1921">
                <div className="flex items-center gap-2 mb-1" data-id="element-1922">
                  {getCategoryIcon(rec.category)}
                  <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${getImpactColor(rec.impact)}`} data-id="element-1923">
                    {rec.impact.charAt(0).toUpperCase() + rec.impact.slice(1)}
                  </span>
                </div>
                <h4 className="text-xs font-medium text-gray-900 mb-0.5" data-id="element-1924">
                  {rec.title}
                </h4>
                <p className="text-xs text-gray-600" data-id="element-1925">{rec.description}</p>
              </div>
              <ChevronRightIcon size={16} className="text-gray-400 group-hover:text-blue-600 transition-colors flex-shrink-0 ml-2" data-id="element-1926" />
            </div>
          </button>)}
      </div>

      <button onClick={() => navigate('/settings')} className="w-full mt-3 text-xs text-blue-600 hover:text-blue-700 font-medium text-center" data-id="element-1927">
        View all recommendations
      </button>
    </div>;
}